import { createSlice } from '@reduxjs/toolkit';
import modifyField from '@/utils/redux/modifyField';
export const initialState = {
    modals: {
        waitingTrips: {
            visibility: false,
            defaultValues: {}
        },
        nextTrip: {
            visibility: false,
            defaultValues: { suggestingTripRequestId: null }
        },
        newTripHasAlreadyStarted: {
            visibility: false,
            defaultValues: {}
        },
        rejectTrip: {
            visibility: false,
            defaultValues: {}
        },
        rejectPlannedTrip: {
            visibility: false,
            defaultValues: {}
        },
        forceCompletedTrip: {
            visibility: false,
            defaultValues: {}
        },
        forceUnassignedTrip: {
            visibility: false,
            defaultValues: {}
        }
    }
};
export const officeTripSlice = createSlice({
    name: 'officeTrip',
    initialState,
    reducers: {
        setOfficeTripPopup: {
            reducer(state, action) {
                const { modal, visibility, defaultValues } = action === null || action === void 0 ? void 0 : action.payload;
                state.modals = modifyField(state.modals, modal, {
                    visibility,
                    defaultValues: Object.assign(Object.assign({}, state.modals[modal].defaultValues), defaultValues)
                });
            },
            prepare(modal, visibility, defaultValues) {
                return { payload: { modal, visibility, defaultValues } };
            }
        }
    }
});
const { setOfficeTripPopup } = officeTripSlice.actions;
export const OfficeTripActionCreators = { setOfficeTripPopup };
export default officeTripSlice.reducer;
